// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"3479":"2aa4518008c671d7","5662":"8ccb0ec0c1428fc5"}[chunkId] + ".css";
};